import { ApplicationConfig, provideBrowserGlobalErrorListeners, provideZonelessChangeDetection } from '@angular/core';
import { provideRouter, withInMemoryScrolling } from '@angular/router';

import { routes } from './app.routes';
import { provideClientHydration, withEventReplay } from '@angular/platform-browser';
import { provideHttpClient, withFetch, withInterceptors, withInterceptorsFromDi } from '@angular/common/http';
import { AppInterceptor } from './core/app-interceptor/app-interceptor';
import { errorInterceptor } from './core/error-interceptor/error-interceptor';
import { pendingRequestsInterceptor$ } from 'ng-http-loader';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZonelessChangeDetection(),
    // each new page opens at the top; Back returns to where the previous page was scrolled
    provideRouter(routes, withInMemoryScrolling({ scrollPositionRestoration: 'enabled' })),
    provideClientHydration(withEventReplay()),

    provideHttpClient(withInterceptors([AppInterceptor, errorInterceptor,pendingRequestsInterceptor$]), withFetch(), withInterceptorsFromDi()),
    provideBrowserGlobalErrorListeners(),
  ]
};
